<template>
  <div slot="no-body" class="tabs-container px-4 pt-4">
    <vs-tabs
      alignment="fixed"
      v-model="activeTab"
      class="tab-action-btn-fill-conatiner"
    >
      <vs-tab :label="$t('admin.heading.userprofile')">
        <div class="tab-text">
          <vx-card>
            <div class="vx-row">
              <div
                class="vx-col w-full lg:w-2/5 md:w-2/5 sm:w-full xs:w-full mb-base"
              >
                <vx-card no-shadow card-border>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <div class="flex items-end px-3">
                        <feather-icon
                          svgClasses="w-6 h-6"
                          icon="UserIcon"
                          class="mr-2"
                        />
                        <span class="font-medium text-lg leading-none">{{
                          $t("admin.heading.usertype")
                        }}</span>
                      </div>
                      <vs-divider />
                    </div>
                  </div>

                  <div class="block overflow-x-auto">
                    <div class="mt-5">
                      <h6>
                        <b>{{ $t("admin.heading.username") }}:</b>
                        <span class="ml-2 text-muted">{{
                          getUserDetail.username
                        }}</span>
                      </h6>
                    </div>

                    <div class="mt-5">
                      <h6>
                        <b>{{ $t("admin.heading.entityname") }}:</b>
                        <span class="ml-2 text-muted">{{
                          getUserDetail.officeName
                        }}</span>
                      </h6>
                    </div>

                    <div class="mt-5">
                      <h6>
                        <b>{{ $t("admin.heading.status") }}:</b>
                        <span class="ml-2 text-muted">Authenticated</span>
                      </h6>
                    </div>

                    <div class="mt-5">
                      <h6>
                        <b>{{ $t("admin.heading.primaryemail") }}:</b>
                        <span class="ml-2 text-muted">{{
                          getUserDetail.email
                        }}</span>
                      </h6>
                    </div>
                  </div>
                </vx-card>
              </div>
              <div class="vx-col w-full lg:w-3/5 md:w-3/5 sm:w-full xs:w-full">
                <vx-card title no-shadow card-border>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <div class="flex items-end px-3">
                        <feather-icon
                          svgClasses="w-6 h-6"
                          icon="UsersIcon"
                          class="mr-2"
                        />
                        <span class="font-medium text-lg leading-none">{{
                          $t("admin.heading.userrole")
                        }}</span>
                      </div>
                      <vs-divider />
                    </div>
                  </div>
                  <div class="block overflow-x-auto">
                    <vs-table stripe :data="getUserDetail.selectedRoles">
                      <template slot="thead">
                        <vs-th
                          class="font-semibold text-base text-left px-3 py-2"
                          >{{ $t("admin.heading.role") }}</vs-th
                        >
                        <vs-th
                          class="font-semibold text-base text-left px-3 py-2"
                          >{{ $t("admin.heading.description") }}</vs-th
                        >
                      </template>

                      <template slot-scope="{ data }">
                        <vs-tr :key="indextr" v-for="(role, indextr) in data">
                          <vs-td>{{ role.name }}</vs-td>

                          <vs-td>{{ role.description }}</vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </vx-card>
              </div>
            </div>
          </vx-card>
        </div>
      </vs-tab>
      <vs-tab :label="$t('admin.heading.changepassword')">
        <div class="tab-text">
          <vx-card>
            <vs-row vs-type="flex" vs-justify="center">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                class="md:w-1/2 lg:w-1/2 sm:w-full"
              >
                <vs-input
                  type="password"
                  class="w-full starlabel"
                  icon-pack="feather"
                  icon="icon-lock"
                  icon-no-border
                  :placeholder="$t('admin.input.password')"
                  v-model="changePassword.password"
                  :danger="isDanger"
                  :danger-text="validationMsg"
                  @input="validatePassword"
                >
                  <template #message-danger> Required </template>
                </vs-input>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-justify="center">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                class="md:w-1/2 lg:w-1/2 sm:w-full"
              >
                <vs-input
                  icon-after="true"
                  icon="icon iconvisibility"
                  v-model="changePassword.repeatPassword"
                  type="password"
                  id="confirmPassword"
                  :placeholder="$t('admin.input.repeatpassword')"
                  class="password w-full mt-8"
                  :visiblePassword="true"
                  v-on:icon-click="visibilityHandling"
                  :danger="isDangerRepeat"
                  :danger-text="RepeatValidationMsg"
                  @input="validateRepeatPassword"
                />
              </vs-col>
            </vs-row>
            <vs-row class="mt-2" vs-type="flex" vs-justify="flex-end">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                class="w-full mt-6 sm:w-full"
              >
                <vs-button
                  color="warning"
                  type="border"
                  class="mr-3 mb-2 mt-3"
                  @click="resetForm"
                  >{{ $t("admin.heading.reset") }}</vs-button
                >
                <vs-button :disabled="disableSubmit" @click="updatePassword">
                  {{ $t("admin.button.submit") }}
                </vs-button>
              </vs-col>
            </vs-row>
          </vx-card>
        </div>
      </vs-tab>
      <vs-tab :label="$t('admin.button.Activitylog')">
        <div class="tab-text">
          <ActivityLog />
        </div>
      </vs-tab>
    </vs-tabs>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { changePassword } from "@/http/auth";
import ActivityLog from "../entity/view-entity/Activity/ActivityLog.vue";
import { removeHeader } from "@/http";
let visiblePassword = false;
export default {
  components: {
    Datepicker,
    ActivityLog,
  },
  data() {
    return {
      isDanger: false,
      validationMsg: null,
      isDangerRepeat: false,
      RepeatValidationMsg: null,
      disableSubmit: true,
      isPasswordValid: true,
      hasVisiblePassword: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      user_data: null,
      user_not_found: false,
      activeTab: 0,
      startDate: "",
      endDate: "",
      activityLog: [
        {
          c_id: "",
          transaction_date: "",
          transaction_type: "",
          History: "",
        },
      ],
      descriptionItems: [3, 5, 10],
      changePassword: {
        password: "",
        repeatPassword: "",
      },
    };
  },
  computed: {
    getUserDetail() {
      return this.$store.getters["auth/userDetail"];
    },
  },
  watch: {
    activeTab(newValue) {
      if (newValue === 1) {
        this.$nextTick(() => {
          this.setupPasswordField();
        });
      }
    },
  },
  methods: {
    validatePassword() {
      const password = this.changePassword.password;
      const lengthRegex = /.{8,}/;
      const specialCharRegex = /[^A-Za-z0-9]/;
      const capitalLetterRegex = /[A-Z]/;
      const numberRegex = /[0-9]/;
      if (password.trim() === "") {
        this.isPasswordValid = false;
        this.validationMessage = "Password is required.";
        this.disableSubmit = true;
        return;
      }
      const isValid =
        lengthRegex.test(password) &&
        specialCharRegex.test(password) &&
        capitalLetterRegex.test(password) &&
        numberRegex.test(password);
      this.isPasswordValid = isValid;
      if (!this.isPasswordValid && this.changePassword.password.length > 0) {
        this.isDanger = true;
        this.validationMsg =
          "Password must be at least 8 characters long, contain atleat one special character, one capital letter, and one number.";
      } else {
        this.isDanger = false;
        this.validationMsg = null;
      }
    },
    validateRepeatPassword() {
      if (this.changePassword.password !== this.changePassword.repeatPassword) {
        this.isDangerRepeat = true;
        this.RepeatValidationMsg =
          "Password mismatch! Please enter correct password.";
        this.disableSubmit = true;
      } else {
        this.isDangerRepeat = false;
        this.RepeatValidationMsg = null;
        this.disableSubmit = false;
      }
    },
    visibilityHandling() {
      this.hasVisiblePassword = !this.hasVisiblePassword;
    },
    setupPasswordField() {
      const passwordField = document.querySelector(".password");
      const iel = document.createElement("i");
      iel.classList.add(
        "vs-icon",
        "notranslate",
        "icon-scale",
        "icon-inputx",
        "notranslate",
        "vs-input--icon",
        "feather",
        "icon",
        "icon-lock",
        "null",
        "icon-no-border"
      );
      passwordField.firstElementChild.append(iel);
      const passwordInput = document.getElementById("confirmPassword");
      const icon = passwordField.querySelector(".vs-input--icon");
      icon.addEventListener("click", function (e) {
        if (visiblePassword) {
          passwordInput.type = "password";
          icon.textContent = "icon iconvisibility";
        } else {
          passwordInput.type = "text";
          icon.textContent = "icon iconvisibility_off";
        }
        visiblePassword = !visiblePassword;
      });
    },
    getOrderStatusColor(status) {
      if (status == "disabled") return "danger";
      if (status == "Enabled") return "success";
      return "primary";
    },
    async updatePassword() {
      if (
        !this.changePassword.password ||
        !this.changePassword.repeatPassword
      ) {
        this.warningPopup = true;
        this.errorMessage = "";
        this.warningText = "Fill the required fields!";
      } else {
        try {
          await changePassword(this.changePassword, this.getUserDetail.id);
          this.$store.dispatch("auth/logout").then((resp) => {
            removeHeader("Authorization");
            sessionStorage.removeItem("ngb:user");
            sessionStorage.removeItem("ngb:bearer_token");
            sessionStorage.removeItem("ngb:user_token");
            this.$router.push("/login");
          });

          this.$swal({
            title: "Success",
            icon: "success",
            text: "Password Changed Successfully!",
            type: "success",
          });
          this.resetForm();
        } catch (e) {
          this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
            "The parameter",
            ""
          );
          this.warningPopup = true;
          this.warningText = "";
          this.errors = e.message.errors;
        }
      }
    },
    capitalizeEveryWord(str) {
      return str
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    resetForm() {
      this.changePassword.password = "";
      this.changePassword.repeatPassword = "";
      this.isDanger = false;
      this.validationMsg = null;
      this.isDangerRepeat = false;
      this.RepeatValidationMsg = null;
      this.disableSubmit = true;
    },
  },
  mounted() {
    this.resetForm();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
#data-list-list-view {
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }
    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }
    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }
    .product-name {
      max-width: 23rem;
    }
    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }
      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }
          &:focus + i {
            left: 1rem;
          }
        }
      }
    }
    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }
    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
    .vs-table--pagination {
      justify-content: center;
    }
  }
}
#confirmPassword {
  padding-left: 3rem !important;
}
.vs-input--input.normal ~ .vs-input--icon.feather {
  top: 7px !important;
}
.vs-input--placeholder {
  top: auto;
}
.vs-input--icon {
  top: 12px !important;
}
.vs-input--icon.icon-after {
  border-left: 0px !important;
  right: 16px !important;
}
.vs-input--input.hasIcon.icon-after-input + .vs-input--placeholder {
  padding-left: 40px !important;
}
.span-text-validation-danger {
  color: red !important;
}
.con-text-validation {
  font-size: 0.75rem;
}
</style>
